var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Button, Chip, Divider, IconButton, InputLabel, ListItemIcon, ListItemText, MenuItem, MenuList, Select, Stack, styled, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Webcam from 'react-webcam';
import { UploadImage } from "../../api/api";
import { deleteUserProfile, DownloadProfilePicUrl, getProductIssueConfigurationURL, organizationStartEndTimeURL, UpdateProfilePicUrlNew, USER_PROFILE_DATA, USER_ROLE } from "../../api/url";
import { BackFrontCamera, BlackBackFrontCamera, CameraIconNewProfile, GalleryIconNew } from "../../assets/images";
import { getProxyProfileContactDetailsUrl } from "../../api/url";
import { InputBox, MuiAvatar, MuiBox, MuiButton, MuiPopup, MuiStack } from "../../components";
import { MuiImagePopUp } from "../../components/atoms/imageDialogBox";
import { MuiSelectComponent } from "../../components/atoms/muiSelectComponent";
import { isModuleConfig, LOCAL_STORAGE_KEYS, Module, ProfileEnum, SPARE_ISSUE_ENUM } from "../../constants";
import { downloadProfileAttachment, setBranchChannelList, setSelectedBranchDetails, showLoader, showNotification } from "../../redux/commonSlice";
import { getByIdAPI, getListAPI, setState } from "../../redux/crudSlice";
import { saveChannelIdDetails, updateProfileDetails } from "../../redux/profileSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { gray, red } from "../../theme/palette";
import { getLocalStorageItem, setLocalStorageItem } from "../../utils/storageHelper";
import { GoogleAnlyticsErrorLog, isExeOrJsFile } from "../../utils/utils";
import { Buffer } from "buffer";
var initialFValues = {
    FirstName: "",
    LastName: "",
    PhoneNo: "",
    EmployeeID: "",
    Email: "",
    Address: "",
    Address2: "",
    Branch: "",
    isEditable: false,
    Channel: "",
    BranchName: "",
    EmployeeDesignation: ''
};
var Img = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "90px",
        width: "90px"
    };
});
var Box = styled(MuiBox)(function (_ref2) {
    var theme = _ref2.theme;
    return {
        borderRadius: "12px"
    };
});
var MuiSelect = styled(Select)(function (_ref3) {
    var theme = _ref3.theme;
    return {
        "& fieldset": {
            border: '1px solid #DEE4EB',
            boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#DEE4EB'
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #AFD5FF",
            borderRadius: "8px",
            boxShadow: "0px 0px 0px 4px rgba(54, 151, 255, 0.24), 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
        },
        '&.Mui-disabled': {
            backgroundColor: '#F4F7FA',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#DEE4EB'
            }
        }
    };
});
var Personaldetails = function (props) {
    var data = props.data, onClosePopup = props.onClosePopup;
    var webcamRef = useRef(null);
    var fileInputRef = useRef(null);
    var dispatch = useAppDispatch();
    var roles = getLocalStorageItem(USER_ROLE);
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var _a = useState(data), values = _a[0], setValues = _a[1];
    var _b = useState(false), checked = _b[0], setChecked = _b[1];
    var _c = useState(false), isCaptureEnable = _c[0], setCaptureEnable = _c[1];
    var _d = useState('user'), facingMode = _d[0], setFacingMode = _d[1];
    var _e = useState([]), selectBranch = _e[0], setSelectedBranch = _e[1];
    var _f = useState(false), isDrawerOpen = _f[0], setISDrawerOpen = _f[1];
    var _g = useState(), file = _g[0], setFile = _g[1];
    var _h = useAppSelector(function (state) { return state.crud; }), profileAttachmentId = _h.profileAttachmentId, ProfilePicUrl = _h.ProfilePicUrl, getContactDetailsData = _h.getContactDetailsData;
    var storedChannelList = getLocalStorageItem(LOCAL_STORAGE_KEYS.CHANNEL_LIST);
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var designationName = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var storedIdentityPersonalizationList = getLocalStorageItem(LOCAL_STORAGE_KEYS.IDENTITY_PERSONALIZATION_LIST);
    var _j = useSelector(function (state) { return state.common.branchChannel; }), getBranchChannelList = _j.getBranchChannelList, selectedBranchChannel = _j.selectedBranchChannel, branchChannelName = _j.branchChannelName;
    var selectedBranchData = useSelector(function (state) { return state.common.selectedBranchDetails; }).selectedBranchData;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('lg'); });
    var medium = useMediaQuery('(min-width:830px) and (max-width:1024px)');
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    useEffect(function () {
        // if (getContactDetailsData?.data?.length === 0)
        getContactDetails();
    }, []);
    var getContactDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "getContactDetailsData",
                        url: getProxyProfileContactDetailsUrl
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var videoConstraints = {
        facingMode: facingMode,
        screenshotQuality: 0.2
    };
    useEffect(function () {
        var _getContactDetailsDat, _getContactDetailsDat2, _getContactDetailsDat3, _getContactDetailsDat4, _getContactDetailsDat5;
        setValues(_objectSpread(_objectSpread({}, values), {}, {
            FirstName: data === null || data === void 0 ? void 0 : data.GivenName,
            LastName: data === null || data === void 0 ? void 0 : data.FamilyName,
            PhoneNo: getContactDetailsData === null || getContactDetailsData === void 0 || (_getContactDetailsDat = getContactDetailsData.data) === null || _getContactDetailsDat === void 0 ? void 0 : _getContactDetailsDat.MobileNumber,
            EmployeeDesignation: getContactDetailsData === null || getContactDetailsData === void 0 || (_getContactDetailsDat2 = getContactDetailsData.data) === null || _getContactDetailsDat2 === void 0 ? void 0 : _getContactDetailsDat2.EmployeeDesignation,
            EmployeeID: data === null || data === void 0 ? void 0 : data.Code,
            Email: getContactDetailsData === null || getContactDetailsData === void 0 || (_getContactDetailsDat3 = getContactDetailsData.data) === null || _getContactDetailsDat3 === void 0 ? void 0 : _getContactDetailsDat3.Email,
            Address: getContactDetailsData === null || getContactDetailsData === void 0 || (_getContactDetailsDat4 = getContactDetailsData.data) === null || _getContactDetailsDat4 === void 0 || (_getContactDetailsDat4 = _getContactDetailsDat4.Addresses) === null || _getContactDetailsDat4 === void 0 ? void 0 : _getContactDetailsDat4.Address1,
            Address2: getContactDetailsData === null || getContactDetailsData === void 0 || (_getContactDetailsDat5 = getContactDetailsData.data) === null || _getContactDetailsDat5 === void 0 || (_getContactDetailsDat5 = _getContactDetailsDat5.Addresses) === null || _getContactDetailsDat5 === void 0 ? void 0 : _getContactDetailsDat5.Address2
            //Branch: data?.Branches
        }));
    }, [data]);
    useEffect(function () {
        if (ProfilePicUrl) {
            setFile(ProfilePicUrl);
        }
        getIdentityPersonalizationList();
    }, []);
    var getOrganizationTiming = function (organizationDetails) { return __awaiter(void 0, void 0, void 0, function () {
        var body, result, _result$payload$value, _result$payload$value2, StartDateTime, EndDateTime;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = {
                        OrganizationId: organizationDetails.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: organizationStartEndTimeURL,
                            request: body
                        }))];
                case 1:
                    result = _a.sent();
                    console.log("result>?>?>?>?", result);
                    if (result.payload.value.success && result.payload.value.data) {
                        StartDateTime = (_result$payload$value = result.payload.value.data.find(function (item) { return item.AttributeName === "StartDateTime"; })) === null || _result$payload$value === void 0 ? void 0 : _result$payload$value.Value;
                        EndDateTime = (_result$payload$value2 = result.payload.value.data.find(function (item) { return item.AttributeName === "EndDateTime"; })) === null || _result$payload$value2 === void 0 ? void 0 : _result$payload$value2.Value;
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.ORGANIZATION_TIMING, {
                            StartDateTime: StartDateTime,
                            EndDateTime: EndDateTime
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getIdentityPersonalizationList = function () {
        if (storedChannelList != null) {
            var _storedIdentityPerson;
            var identityList = (_storedIdentityPerson = storedIdentityPersonalizationList === null || storedIdentityPersonalizationList === void 0 ? void 0 : storedIdentityPersonalizationList.Value) !== null && _storedIdentityPerson !== void 0 ? _storedIdentityPerson : {};
            if (identityList !== null && identityList !== void 0 && identityList.BranchDetails) {
                var _identityList$Channel, _identityList$Channel2, _identityList$BranchD, _identityList$BranchD2;
                dispatch(setBranchChannelList({
                    getBranchChannelList: storedChannelList,
                    selectedBranchChannel: storedSelectedChannel
                }));
                setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH, identityList === null || identityList === void 0 ? void 0 : identityList.BranchDetails);
                getOrganizationTiming(identityList === null || identityList === void 0 ? void 0 : identityList.BranchDetails);
                setValues(_objectSpread(_objectSpread({}, values), {}, {
                    Channel: (_identityList$Channel = identityList === null || identityList === void 0 || (_identityList$Channel2 = identityList.ChannelDetails) === null || _identityList$Channel2 === void 0 ? void 0 : _identityList$Channel2.ChannelId) !== null && _identityList$Channel !== void 0 ? _identityList$Channel : "",
                    BranchName: (_identityList$BranchD = identityList === null || identityList === void 0 || (_identityList$BranchD2 = identityList.BranchDetails) === null || _identityList$BranchD2 === void 0 ? void 0 : _identityList$BranchD2.OrganizationId) !== null && _identityList$BranchD !== void 0 ? _identityList$BranchD : ""
                }));
            }
            else {
                dispatch(setBranchChannelList({
                    getBranchChannelList: storedChannelList,
                    selectedBranchChannel: storedSelectedChannel
                }));
                setValues(_objectSpread(_objectSpread({}, values), {}, {
                    Channel: storedSelectedChannel !== null && storedSelectedChannel !== void 0 && storedSelectedChannel.ChannelId ? storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId : "",
                    BranchName: storedSelectedBranch !== null && storedSelectedBranch !== void 0 && storedSelectedBranch.OrganizationId ? storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId : ""
                }));
                var branchSelected_1 = storedChannelList[0].BranchDetails.map(function (item) { return item.OrganizationName; });
                setSelectedBranch(branchSelected_1);
            }
            var branchSelected = storedSelectedChannel.BranchDetails.map(function (item) { return item.OrganizationName; });
            setSelectedBranch(branchSelected);
        }
    };
    var handleChange = function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
            _a[name] = value,
            _a)));
    };
    var toBase64 = function (file) { return new Promise(function (resolve, reject) {
        if (file) {
            var reader_1 = new FileReader();
            reader_1.readAsDataURL(file);
            reader_1.onload = function () { return resolve(reader_1.result); };
            reader_1.onerror = reject;
        }
    }); };
    var takingContactGroupDesignation = function () {
        var _roles$data, _roles$data2;
        var serviceAdviserRole = roles === null || roles === void 0 || (_roles$data = roles.data) === null || _roles$data === void 0 ? void 0 : _roles$data.find(function (item) { return item.DesignationName === "Service Advisor"; });
        var FinalInspectorRole = roles === null || roles === void 0 || (_roles$data2 = roles.data) === null || _roles$data2 === void 0 ? void 0 : _roles$data2.find(function (item) { return item.DesignationName === "Final Inspector"; });
        if ((designationName === null || designationName === void 0 ? void 0 : designationName.DesignationName) == 'Service Advisor') {
            var item = {
                ContactGroupId: serviceAdviserRole.ContactGroupId,
                DesignationId: serviceAdviserRole.DesignationId
            };
            return item;
        }
        else if ((designationName === null || designationName === void 0 ? void 0 : designationName.DesignationName) == 'Final Inspector') {
            var item = {
                ContactGroupId: FinalInspectorRole.ContactGroupId,
                DesignationId: FinalInspectorRole.DesignationId
            };
            return item;
        }
    };
    function dataURLtoFile(dataurl, filename) {
        var _arr$;
        var arr = dataurl.split(','), mime = (_arr$ = arr[0]) === null || _arr$ === void 0 || (_arr$ = _arr$.match(/:(.*?);/)) === null || _arr$ === void 0 ? void 0 : _arr$[1], bstr = atob(arr[arr.length - 1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {
            type: mime
        });
    }
    var capture = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _webcamRef$current, imageSrc, _userData$data, convertedFile, imageSizeInBytes, formData, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    imageSrc = (_webcamRef$current = webcamRef.current) === null || _webcamRef$current === void 0 ? void 0 : _webcamRef$current.getScreenshot();
                    if (!imageSrc) return [3 /*break*/, 2];
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    convertedFile = dataURLtoFile(imageSrc, 'profile.png');
                    imageSizeInBytes = convertedFile.size;
                    if (imageSizeInBytes > 5 * 1024 * 1024) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("File size exceeds 5 MB. Please choose a smaller file"));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("File size exceeds 5 MB. Please choose a smaller file"),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        return [2 /*return*/];
                    }
                    setCaptureEnable(false);
                    formData = new FormData();
                    formData.append('data', convertedFile);
                    return [4 /*yield*/, UploadImage(UpdateProfilePicUrlNew(userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId), formData, 'Identity', dispatch)];
                case 1:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && response.success && (response === null || response === void 0 ? void 0 : response.statusCode) == 200) {
                        downloadProfileImage(response);
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Profile uploaded successfully"),
                            type: "success"
                        }));
                    }
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.log("Error-", e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [webcamRef]);
    var handleFileChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _e$target, _userData$data2, allowedExtensions, _i, _a, file_1, extension, fileSizeInMB, arrayBuffer, buffer, error_1, formData, response, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 8, , 9]);
                    // Check if files exist
                    if (!((_e$target = e.target) !== null && _e$target !== void 0 && _e$target.files) || e.target.files.length === 0) {
                        return [2 /*return*/];
                    }
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    allowedExtensions = ['.png', '.jpeg', '.jpg'];
                    _i = 0, _a = e.target.files;
                    _b.label = 1;
                case 1:
                    if (!(_i < _a.length)) return [3 /*break*/, 6];
                    file_1 = _a[_i];
                    extension = ".".concat(file_1.name.split('.').pop().toLowerCase());
                    // Check file extension
                    if (!allowedExtensions.includes(extension)) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("Only PNG, JPEG, JPG files are allowed."));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Only PNG, JPEG, JPG files are allowed."),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    fileSizeInMB = file_1.size / 1024 / 1024;
                    if (fileSizeInMB >= 5) {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("File size exceeds 5 MB. Please choose a smaller file"));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("File size exceeds 5 MB. Please choose a smaller file"),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, file_1.arrayBuffer()];
                case 3:
                    arrayBuffer = _b.sent();
                    buffer = Buffer.from(new Uint8Array(arrayBuffer));
                    if (isExeOrJsFile(buffer)) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("The file format is invalid and not allowed."),
                            type: "error"
                        }));
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    console.error('Error processing file:', error_1);
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Error processing file. Please try again."),
                        type: "error"
                    }));
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    e.target.value = '';
                    return [2 /*return*/];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6:
                    formData = new FormData();
                    formData.append('data', e.target.files[0]);
                    return [4 /*yield*/, UploadImage(UpdateProfilePicUrlNew(userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.IdentityId), formData, 'Identity', dispatch)];
                case 7:
                    response = _b.sent();
                    if (response !== null && response !== void 0 && response.success && (response === null || response === void 0 ? void 0 : response.statusCode) == 200) {
                        downloadProfileImage(response);
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Profile uploaded successfully"),
                            type: "success"
                        }));
                    }
                    // Clear input
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    return [3 /*break*/, 9];
                case 8:
                    error_2 = _b.sent();
                    console.error('Error in handleFileChange:', error_2);
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("An error occurred while processing the file."),
                        type: "error"
                    }));
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var downloadProfileImage = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _userData$data3, _userData$data4, base64, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!(userData !== null && userData !== void 0 && (_userData$data3 = userData.data) !== null && _userData$data3 !== void 0 && _userData$data3.IdentityId && data !== null && data !== void 0 && data.attachmentId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, downloadProfileAttachment(userData === null || userData === void 0 || (_userData$data4 = userData.data) === null || _userData$data4 === void 0 ? void 0 : _userData$data4.IdentityId, data === null || data === void 0 ? void 0 : data.attachmentId, DownloadProfilePicUrl)];
                case 1:
                    base64 = _a.sent();
                    if (base64) {
                        setFile(base64);
                        dispatch(setState({
                            key: "profileAttachmentId",
                            value: data === null || data === void 0 ? void 0 : data.attachmentId
                        }));
                        dispatch(setState({
                            key: "ProfilePicUrl",
                            value: base64
                        }));
                    }
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    console.log("Error-", e_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var RemovePhoto = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        SystemName: ProfileEnum.Identity,
                        AttachmentId: profileAttachmentId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: deleteUserProfile,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if ((_response$payload = response.payload) !== null && _response$payload !== void 0 && _response$payload.value.success) {
                        setFile(null);
                        setISDrawerOpen(false);
                        if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                        }
                        dispatch(setState({
                            key: "ProfilePicUrl",
                            value: ''
                        }));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Profile photo removed"),
                            type: "success"
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSaveClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _values$Email, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        MobileNo: values.PhoneNo,
                        Email: (_values$Email = values.Email) !== null && _values$Email !== void 0 ? _values$Email : ""
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(updateProfileDetails(request))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var openCamera = function () {
        // setFile(null)
        setCaptureEnable(true);
        setChecked(false);
    };
    var openFileInput = function (e) {
        e.preventDefault();
        if (fileInputRef !== null && fileInputRef !== void 0 && fileInputRef.current) {
            fileInputRef.current.click();
        }
        setChecked(false);
    };
    var switchCamera = function () {
        setFacingMode(function (prevFacingMode) { return prevFacingMode === 'user' ? 'environment' : 'user'; });
    };
    var Menulist = function () {
        return /*#__PURE__*/ React.createElement(MenuList, {
            sx: {
                paddingRight: "30px"
            }
        }, /*#__PURE__*/ React.createElement(MenuItem, null, /*#__PURE__*/ React.createElement(ListItemIcon, null, /*#__PURE__*/ React.createElement(Img, {
            src: CameraIconNewProfile,
            alt: "ClosecircleIcon",
            id: "",
            sx: {
                height: "24px",
                width: "24px"
            }
        })), /*#__PURE__*/ React.createElement(ListItemText, {
            onClick: openCamera
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
            id: "camera",
            variant: "h3",
            sx: {
                padding: "10px 10px 10px 0px"
            }
        }, t("Camera")), /*#__PURE__*/ React.createElement(Typography, {
            id: "takePictureId",
            variant: "h4",
            sx: {
                padding: "10px 10px 10px 0px"
            },
            color: gray
        }, t("Take a picture"))))), /*#__PURE__*/ React.createElement(MenuItem, null, /*#__PURE__*/ React.createElement(ListItemIcon, null, /*#__PURE__*/ React.createElement(Img, {
            id: "galleryIcon",
            src: GalleryIconNew,
            alt: "ClosecircleIcon",
            sx: {
                height: "24px",
                width: "24px"
            }
        })), /*#__PURE__*/ React.createElement(ListItemText, {
            onClick: openFileInput
        }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3",
            id: "galleryBtn",
            sx: {
                padding: "10px 10px 10px 0px"
            }
        }, t("Gallery")), /*#__PURE__*/ React.createElement(Typography, {
            id: "choosePic",
            variant: "h4",
            sx: {
                padding: "10px 10px 10px 0px"
            },
            color: gray
        }, t("Choose an existing photo"))))));
    };
    var handleClick = function (event) {
        // setAnchorEl(event.currentTarget);
        setChecked(true);
    };
    // const selectedBranches = values?.Branch ? values?.Branch?.map((branch : any) => branch.OrganizationName)) : [];
    var handleInputChangeChannel = function (e) {
        var _a;
        var filterData = getBranchChannelList.filter(function (item) {
            var _e$target2;
            return item.ChannelId == (e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.value);
        });
        var _b = e === null || e === void 0 ? void 0 : e.target, name = _b.name, value = _b.value;
        dispatch(setBranchChannelList({
            getBranchChannelList: getBranchChannelList,
            selectedBranchChannel: filterData[0]
        }));
        setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
            _a[name] = value,
            _a.BranchName = "",
            _a)));
    };
    var handleInputChangeBranch = function (e) {
        var _a;
        var _selectedBranchChanne;
        var _b = e === null || e === void 0 ? void 0 : e.target, name = _b.name, value = _b.value;
        setValues(_objectSpread(_objectSpread({}, values), {}, (_a = {},
            _a[name] = value,
            _a)));
        var filterData = selectedBranchChannel === null || selectedBranchChannel === void 0 || (_selectedBranchChanne = selectedBranchChannel.BranchDetails) === null || _selectedBranchChanne === void 0 ? void 0 : _selectedBranchChanne.filter(function (item) {
            var _e$target3;
            return item.OrganizationId == (e === null || e === void 0 || (_e$target3 = e.target) === null || _e$target3 === void 0 ? void 0 : _e$target3.value);
        });
        dispatch(setSelectedBranchDetails({
            selectedBranchData: filterData[0]
        }));
    };
    var onSaveButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload2, _response$payload3, payload, response, _response$payload4, data_1, _data$BranchDetails, _data$ChannelDetails;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = {
                        // selectedBranchChannel: selectedBranchChannel,
                        // selectedBranchData: selectedBranchData ? selectedBranchData : storedSelectedBranch
                        selectedBranchChannel: selectedBranchChannel !== null && selectedBranchChannel !== void 0 && selectedBranchChannel.ChannelId ? selectedBranchChannel : storedSelectedChannel,
                        selectedBranchData: selectedBranchData !== null && selectedBranchData !== void 0 && selectedBranchData.OrganizationId ? selectedBranchData : storedSelectedBranch
                    };
                    return [4 /*yield*/, dispatch(saveChannelIdDetails(payload))];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.payload) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) === 200 && response !== null && response !== void 0 && (_response$payload3 = response.payload) !== null && _response$payload3 !== void 0 && (_response$payload3 = _response$payload3.payload) !== null && _response$payload3 !== void 0 && _response$payload3.success) {
                        onClosePopup(false);
                        data_1 = response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.payload) === null || _response$payload4 === void 0 || (_response$payload4 = _response$payload4.data) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.Value;
                        if (Module === isModuleConfig.Product) {
                            //Changing for bajaj release
                            getProductIssueConfiguration(data_1 === null || data_1 === void 0 || (_data$BranchDetails = data_1.BranchDetails) === null || _data$BranchDetails === void 0 ? void 0 : _data$BranchDetails.OrganizationId, data_1 === null || data_1 === void 0 || (_data$ChannelDetails = data_1.ChannelDetails) === null || _data$ChannelDetails === void 0 ? void 0 : _data$ChannelDetails.ChannelId);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getProductIssueConfiguration = function (organizationId, channelId) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, _result$payload3, request, result, _result$payload4, _multipleDocArray$Val, _multipleDocArray, multipleDocArray, multipleDocValue;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        OrganizationId: organizationId !== null && organizationId !== void 0 ? organizationId : '',
                        ChannelId: channelId !== null && channelId !== void 0 ? channelId : ''
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getProductIssueConfigurationURL,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success && (result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.value) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.statusCode) == 200 && (result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.value) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.data) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.AllocationSubTypes) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.length) > 0) {
                        multipleDocArray = [];
                        multipleDocArray = result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.value) === null || _result$payload4 === void 0 || (_result$payload4 = _result$payload4.data) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.AllocationSubTypes.find(function (item) { return item.Key === SPARE_ISSUE_ENUM.MultipleDocument; });
                        multipleDocValue = (_multipleDocArray$Val = (_multipleDocArray = multipleDocArray) === null || _multipleDocArray === void 0 ? void 0 : _multipleDocArray.Value) !== null && _multipleDocArray$Val !== void 0 ? _multipleDocArray$Val : false;
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC, multipleDocValue);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        setISDrawerOpen(false);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("input", {
        //max={"2048"}
        id: "upload-profile-image",
        type: "file",
        ref: fileInputRef,
        style: {
            display: 'none'
        },
        onChange: handleFileChange,
        accept: "image/*"
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1.5,
        direction: "column"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(MuiAvatar, {
        sx: {
            height: 64,
            width: 64
        },
        src: file,
        onClick: function () { return setISDrawerOpen(true); }
    }), /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        justifyContent: "end",
        columnGap: 1
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "text",
        onClick: RemovePhoto,
        disabled: !file,
        color: "secondary",
        id: "removeImage"
    }, t('Remove')), /*#__PURE__*/ React.createElement(Button, {
        id: "changeImage",
        variant: "outlined",
        onClick: handleClick
    }, file ? t('Change image') : t('Upload image'))), file && isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: file
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 2
    }, /*#__PURE__*/ React.createElement(InputLabel, null, t("First name")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "firstName",
        size: "small",
        style: {
            marginTop: '8px'
        },
        value: values === null || values === void 0 ? void 0 : values.FirstName,
        name: "FirstName",
        onChange: handleChange,
        disabled: true
    })), /*#__PURE__*/ React.createElement(InputLabel, null, t("Last name")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "lastName",
        size: "small",
        style: {
            marginTop: '8px'
        },
        value: values === null || values === void 0 ? void 0 : values.LastName,
        name: "LastName",
        onChange: handleChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputLabel, null, t("Phone")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "phoneNo",
        size: "small",
        style: {
            marginTop: '8px'
        },
        value: values === null || values === void 0 ? void 0 : values.PhoneNo,
        name: "PhoneNo",
        onChange: handleChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputLabel, null, t("Employee Designation")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "EmployeeDesignation",
        size: "small",
        style: {
            marginTop: '8px'
        },
        value: values === null || values === void 0 ? void 0 : values.EmployeeDesignation,
        name: "EmployeeDesignation",
        onChange: handleChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputLabel, null, t("Employee ID")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "empId",
        size: "small",
        style: {
            marginTop: '8px'
        },
        value: values === null || values === void 0 ? void 0 : values.EmployeeID,
        name: "EmployeeID",
        onChange: handleChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputLabel, null, t("Email")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "emailId",
        size: "small",
        style: {
            marginTop: '8px'
        },
        value: values === null || values === void 0 ? void 0 : values.Email,
        name: "Email",
        onChange: handleChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputLabel, null, t("Address")), /*#__PURE__*/ React.createElement(InputBox, {
        id: "address",
        size: "small",
        style: {
            marginTop: '8px'
        },
        value: values === null || values === void 0 ? void 0 : values.Address,
        name: "Address1",
        onChange: handleChange,
        disabled: true
    }), /*#__PURE__*/ React.createElement(InputBox, {
        id: "multiline-input",
        multiline: true,
        rows: 3,
        style: {
            marginTop: '10px'
        },
        value: values === null || values === void 0 ? void 0 : values.Address2,
        name: "Address2",
        onChange: handleChange,
        disabled: true
    }), getBranchChannelList.length > 1 && Module === isModuleConfig.Product && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(InputLabel, null, t("Channel")), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "channelId",
        caption: "channel",
        fullWidth: true,
        options: getBranchChannelList || [],
        displayExpr: "ChannelName",
        valueExpr: "ChannelId",
        name: "Channel",
        value: values !== null && values !== void 0 && values.Channel ? values === null || values === void 0 ? void 0 : values.Channel : '',
        onChange: function (event) { return handleInputChangeChannel(event); },
        disabled: (getBranchChannelList === null || getBranchChannelList === void 0 ? void 0 : getBranchChannelList.length) === 1
        //error={errors?.ChannelName}
    })), /*#__PURE__*/ React.createElement(InputLabel, null, t("Branch")), getBranchChannelList.length > 1 ? /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "branchId",
        caption: "branch",
        fullWidth: true,
        options: selectedBranchChannel === null || selectedBranchChannel === void 0 ? void 0 : selectedBranchChannel.BranchDetails,
        displayExpr: "OrganizationName",
        valueExpr: "OrganizationId",
        name: "BranchName",
        value: values.BranchName ? values.BranchName : '',
        onChange: function (event) { return handleInputChangeBranch(event); },
        disabled: !values.Channel
        //error={errors?.OrganizationName}
    }) : /*#__PURE__*/ React.createElement("div", {
        style: {
            border: '1px solid #DEE4EB',
            padding: '10px',
            borderRadius: '8px',
            backgroundColor: '#F4F7FA',
            height: '70px',
            overflowY: 'auto'
        }
    }, selectBranch === null || selectBranch === void 0 ? void 0 : selectBranch.map(function (item) {
        console.log("item", item);
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                flexWrap: 'wrap',
                marginBottom: '3px'
            }
        }, /*#__PURE__*/ React.createElement(Chip, {
            id: "branchId",
            key: item + 1,
            label: item
        }));
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        width: "100%",
        justifyContent: "space-between",
        spacing: 3,
        paddingTop: 1
    }, getBranchChannelList.length > 1 && /*#__PURE__*/ React.createElement(MuiButton, {
        fullWidth: true,
        size: "medium",
        name: t("Save"),
        variant: "contained",
        onClick: onSaveButtonClick,
        disabled: !(values.Channel && values.BranchName)
    })), /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: checked,
        title: /*#__PURE__*/ React.createElement(Typography, {
            variant: "h1"
        }, t("Select Photo")),
        closeIcon: true,
        onClose: function () { return setChecked(function (prev) { return !prev; }); },
        backdropEnable: true,
        containerStyle: {
            padding: '0px 8px 0px 8px',
            width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            color: red
        },
        padding: "8px 16px 0 16px"
    }, "*" + t("FILE_SIZE_MESSAGE"))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(Menulist, null))), isCaptureEnable && /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: isCaptureEnable,
        borderRadius: 0,
        containerStyle: {
            padding: '0',
            width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            padding: '0px',
            overflow: 'hidden',
            width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(Webcam, {
        audio: false,
        width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        //height={"80%"}
        ,
        ref: webcamRef,
        screenshotFormat: "image/jpeg",
        videoConstraints: videoConstraints
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        sx: {
            position: 'relative',
            margin: "0",
            padding: '10px',
            backgroundColor: 'white',
            width: isDesktop ? 'calc(40vw)' : medium ? 'calc(60vw)' : lgMode ? 'calc(72vw)' : 'calc(90vw)'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: switchCamera
    }, facingMode == "user" ? /*#__PURE__*/ React.createElement("img", {
        src: BlackBackFrontCamera,
        alt: "camera"
    }) : /*#__PURE__*/ React.createElement("img", {
        src: BackFrontCamera,
        alt: "camera"
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: "space-between",
        gap: '10px'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        name: t("Close"),
        onClick: function () { return setCaptureEnable(false); }
    }), /*#__PURE__*/ React.createElement(MuiButton, {
        name: t("Capture"),
        onClick: capture
    }))))));
};
export default Personaldetails;
